<template>
  <div class="row">
    <!--  申请咨询列表  -->
    <div class="flex xs12">
      <va-card title="申请咨询列表">
        <div class="row align-center mb-1">
          <div class="flex md12 xs12">
            <va-button-group>
              <va-button class="mb-2" flat disabled color="gray">处理状态：</va-button>
              <va-button class="mb-2" flat :color="computeStatusColor(null)" v-on:click="handleStatusChange(null)" >全部</va-button>
              <va-button
                class="mb-2"
                v-for="status in appliedConsultingStatusType"
                :key="status.CODE"
                :color="computeStatusColor(status.CODE)"
                flat
                v-on:click="handleStatusChange(status.CODE)"
              >{{status.TEXT}}</va-button>
              <va-button class="mb-2" flat disabled color="danger">总计{{totalCount}}条结果</va-button>
            </va-button-group>
          </div>
          <div class="flex md6 xs12 sm6">
            <va-input
              class="mb-2"
              :value="consultingUid"
              placeholder="搜索咨询UID"
              @input="searchConsultingUid"
              removable
            >
              <va-icon name="fa fa-search" slot="prepend"/>
            </va-input>
          </div>
          <va-button flat disabled color="red">开始时间和结束时间均为运营人员本地的时区，并不是用户的时区</va-button>
        </div>
        <va-data-table
          :fields="fields"
          :data="appliedConsultings"
          :loading="loading"
          :totalPages="totalPages"
          class="force-wrap"
          @page-selected="listAppliedConsulting"
          api-mode
        >
          <template slot="avatar" slot-scope="props">
            <img :src="props.rowData.user.avatar" class="data-table-server-pagination---avatar" alt="avatar">
          </template>
          <template slot="user" slot-scope="props">
            <va-button color="gray" flat small :to='{path:`/admin/users/updateUser/${props.rowData.user.uid}`}'>
              {{ props.rowData.user.nickname }}
            </va-button>
          </template>
          <template slot="consulting" slot-scope="props">
            <va-button color="gray" flat small :to='{path:`/admin/consultings/updateConsulting/${props.rowData.consulting.uid}`}'>
              {{ props.rowData.consulting.topic }}
            </va-button>
          </template>
          <template slot="statusSlot" slot-scope="props">
            <va-badge color= 'info'>
              {{ computeAppliedConsultingStatus(props.rowData.status).text }}
            </va-badge>
          </template>
          <template slot="actions" slot-scope="props">
            <va-popover message="查看" placement="top">
              <va-button flat small color="gray" icon="fa fa-eye"
                :to='{path:`getAppliedConsulting/${props.rowData.id}`}'/>
            </va-popover>
            <va-popover message="删除" placement="top">
              <va-button flat small color="gray" icon="fa fa-trash"
                @click="deleteModal = true;deleteId=props.rowData.id"/>
            </va-popover>
          </template>
        </va-data-table>

        <va-modal
          v-model="deleteModal"
          title="删除报名"
          okText="提交"
          position="center"
          message="请再次确认是否要删除？"
          @ok="confirmDelete"
        />

      </va-card>
    </div>
  </div>
</template>

<script>

import debounce from 'lodash/debounce'
import appliedConsultingApi from '../../../api/appliedConsulting'
import { USER_APPLICATION_STATUS_TYPES } from '../../../utils/constants'
import { formatTime, getZoneTime } from '@/utils/common'
export default {
  data () {
    return {
      message: ['Required field'],
      consultingUid: this.$route.query.consultingUid,
      userUid: this.$route.query.userUid,
      appliedConsultings: [],
      loading: true,
      pageNumber: 1,
      pageSize: 10,
      totalPages: 1,
      totalCount: 0,
      deleteModal: false,
      deleteId: null,
      status: null,
      appliedConsultingStatusType: USER_APPLICATION_STATUS_TYPES,
    }
  },
  computed: {
    fields () {
      return [
        {
          name: '__slot:avatar',
          title: '学员头像',
          width: '60px',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:user',
          title: '学员姓名',
          width: '13%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:statusSlot',
          title: '处理状态',
          width: '13%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:consulting',
          title: '咨询话题',
          width: '13%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'userTimeZone',
          title: '用户时区',
          width: '13%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'startTime',
          title: '开始时间',
          width: '13%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'endTime',
          title: '结束时间',
          width: '13%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:actions',
          title: '操作',
          width: '13%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
      ]
    },
  },
  created () {
    this.listAppliedConsulting()
  },
  methods: {
    listAppliedConsulting (pageNumber = this.pageNumber) {
      this.loading = true
      const params = {
        pageSize: this.pageSize,
        pageNumber: pageNumber,
        userUid: this.userUid,
        consultingUid: this.consultingUid,
        status: this.status,
      }
      appliedConsultingApi.listAppliedConsulting(params).then(response => {
        this.appliedConsultings = response.appliedConsultings
        this.appliedConsultings.forEach(x => {
          x.createTime = formatTime(x.createTime)
          x.startTime = formatTime(x.startTime)
          x.endTime = formatTime(x.endTime)
        })
        this.totalPages = response.pages.totalPage
        this.totalCount = response.pages.totalCount
        this.pageNumber = pageNumber
        this.loading = false
      }).catch(error => alert(error))
    },
    computeStatusColor (status) {
      return status === this.status ? 'info' : 'gray'
    },
    handleStatusChange (status) {
      this.status = status
      this.listAppliedConsulting()
    },
    confirmDelete () {
      if (this.deleteUid === null) return
      appliedConsultingApi.deleteAppliedConsulting(this.deleteId).then(response => {
        if (response.success === true) {
          this.showToast('删除报名成功', {
            duration: 1000,
            icon: 'fa-check',
            position: 'top-center',
            fullWidth: false,
          })
          this.listAppliedConsulting()
        }
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    searchUserUid: debounce(function (userUid) {
      this.userUid = userUid
      if (this.userUid === '') { this.userUid = null }
      this.listAppliedConsulting()
    }, 400),
    searchConsultingUid: debounce(function (consultingUid) {
      this.consultingUid = consultingUid
      if (this.consultingUid === '') { this.consultingUid = null }
      this.listAppliedConsulting()
    }, 400),
    computeAppliedConsultingStatus (status) {
      const data = {
        text: '',
      }
      this.appliedConsultingStatusType.map(x => {
        if (x.CODE === status) {
          data.text = x.TEXT
        }
      })
      return data
    },
  },
}

</script>
<style lang="scss">
.data-table-server-pagination---avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}
</style>
<style lang="scss">
.force-wrap td {
  word-break: break-word; /* 文本行的任意字内断开 */
  word-wrap: break-word; /* IE */
  white-space: -moz-pre-wrap; /* Mozilla */
  white-space: -hp-pre-wrap; /* HP printers */
  white-space: -o-pre-wrap; /* Opera 7 */
  white-space: -pre-wrap; /* Opera 4-6 */
  white-space: pre; /* CSS2 */
  white-space: pre-wrap; /* CSS 2.1 */
  white-space: pre-line; /* CSS 3 (and 2.1 as well, actually) */
}
</style>
